module.exports = __webpack_public_path__ + "img/emotions.8a727ca7.png";